import type { PortableTextBlock } from "@portabletext/types";
import clsx from "clsx";
import { ChevronUpIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { useSessionStorage } from "react-use";

import TextBlock from "./TextBlock";

const Abstract = ({ abstract }: { abstract: Array<PortableTextBlock> }) => {
	const [storedHiddenState, setHiddenState] = useSessionStorage(
		"abstract-hidden",
		false,
	);
	const [hasMounted, setHasMounted] = useState(false);

	useEffect(() => {
		setHasMounted(true);
	}, []);

	// This fixes a hydration error by waiting till the component is mounted to evaluate if the abstract should be hidden
	const isHidden = hasMounted ? storedHiddenState : false;
	return (
		<div
			className={
				"my-3 rounded-xl border border-slate-200 p-3 dark:border-slate-600"
			}
		>
			<div className="flex flex-row items-center justify-between">
				<h1 className="font-bold text-xl">Abstract:</h1>
				<button
					className={
						"flex select-none items-center gap-0.5 rounded-full bg-slate-700 px-3 py-1.5 font-medium text-white shadow-black/5 shadow-xl hover:bg-slate-600 disabled:opacity-70 dark:bg-slate-600 dark:shadow-black/10 dark:hover:bg-slate-700"
					}
					onClick={() => setHiddenState(!storedHiddenState)}
				>
					{isHidden ? "Expand" : "Collapse"}
					<ChevronUpIcon
						size={20}
						className={clsx(
							"transition-transform",
							isHidden ? "rotate-180" : "",
						)}
					/>
				</button>
			</div>
			{isHidden ? null : (
				<div className="pt-4">
					<TextBlock value={abstract} />
				</div>
			)}
		</div>
	);
};

export default Abstract;
